/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LegalPersonResource } from './';
import {
    LegalPersonResourceFromJSON,
    LegalPersonResourceFromJSONTyped,
    LegalPersonResourceToJSON,
} from './';
import type { ModelCompanyTypeResource } from './';
import {
    ModelCompanyTypeResourceFromJSON,
    ModelCompanyTypeResourceFromJSONTyped,
    ModelCompanyTypeResourceToJSON,
} from './';
import type { TaxesResource } from './';
import {
    TaxesResourceFromJSON,
    TaxesResourceFromJSONTyped,
    TaxesResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelanceCompanyResource
 */
export interface FreelanceCompanyResource {
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyResource
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyResource
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyResource
     */
    vatNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyResource
     */
    registrationNumber?: string;
    /**
     * 
     * @type {ModelCompanyTypeResource}
     * @memberof FreelanceCompanyResource
     */
    type?: ModelCompanyTypeResource;
    /**
     * 
     * @type {LegalPersonResource}
     * @memberof FreelanceCompanyResource
     */
    legalPerson?: LegalPersonResource;
    /**
     * 
     * @type {boolean}
     * @memberof FreelanceCompanyResource
     */
    complianceNeeded: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FreelanceCompanyResource
     */
    legalNoticesValues: { [key: string]: string; };
    /**
     * 
     * @type {Array<TaxesResource>}
     * @memberof FreelanceCompanyResource
     */
    taxes: Array<TaxesResource>;
}

/**
 * Check if a given object implements the FreelanceCompanyResource interface.
 */
export function instanceOfFreelanceCompanyResource(value: object): value is FreelanceCompanyResource {
    if (!('complianceNeeded' in value) || value['complianceNeeded'] === undefined) return false;
    if (!('legalNoticesValues' in value) || value['legalNoticesValues'] === undefined) return false;
    if (!('taxes' in value) || value['taxes'] === undefined) return false;
    return true;
}

export function FreelanceCompanyResourceFromJSON(json: any): FreelanceCompanyResource {
    return FreelanceCompanyResourceFromJSONTyped(json, false);
}

export function FreelanceCompanyResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelanceCompanyResource {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'name': json['name'] == null ? undefined : json['name'],
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'type': json['type'] == null ? undefined : ModelCompanyTypeResourceFromJSON(json['type']),
        'legalPerson': json['legalPerson'] == null ? undefined : LegalPersonResourceFromJSON(json['legalPerson']),
        'complianceNeeded': json['complianceNeeded'],
        'legalNoticesValues': json['legalNoticesValues'],
        'taxes': ((json['taxes'] as Array<any>).map(TaxesResourceFromJSON)),
    };
}

export function FreelanceCompanyResourceToJSON(value?: FreelanceCompanyResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyId': value['companyId'],
        'name': value['name'],
        'vatNumber': value['vatNumber'],
        'registrationNumber': value['registrationNumber'],
        'type': ModelCompanyTypeResourceToJSON(value['type']),
        'legalPerson': LegalPersonResourceToJSON(value['legalPerson']),
        'complianceNeeded': value['complianceNeeded'],
        'legalNoticesValues': value['legalNoticesValues'],
        'taxes': ((value['taxes'] as Array<any>).map((v) => TaxesResourceToJSON(v))),
    };
}

